var Actions;
(function (Actions) {
    Actions["GET_MASTER_PA_LIST"] = "getAllPAList";
    Actions["DELETE_LIST"] = "handlePADeleteList";
    Actions["HANDLE_SORT_CHANGE"] = "handlePAListSortChange";
    Actions["HANDLE_CURRENT_PAGE_CHANGE"] = "handleMasterSchemaListPageChange";
    Actions["HANDLE_CURRENT_PAGE_CHANGE_ON_SORT"] = "handleMasterSchemaListPageChangeOnSort";
    // post data
    Actions["POST_DATA"] = "postPAData";
    Actions["UPDATE_DATA"] = "updatePAData";
    Actions["GET_NIK_DETAIL_OPTIONS"] = "getPANikDetailOptions";
    Actions["GET_SCHEMA_OPTIONS"] = "getPASchemaOptions";
    Actions["POST_SCHEDULE"] = "postPreAssessmentSchedule";
    Actions["GET_PA_SCHEDULE_AVAILABILITIES"] = "getPreAsessmentScheduleAvailbilities";
    Actions["EXPORT_PA_SCHEDULE"] = "exportPreAssessmentSchedule";
    Actions["DOWNLOAD_PA_SCHEDULE"] = "downloadPreAssessmentSchedule";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_MASTER_PA_LIST"] = "setPAList";
    Mutations["SET_PAGINATION_TOTAL_PAGE"] = "setPAListPaginationTotalPage";
    Mutations["SET_PAGINATION_LOADING"] = "setMasterSchemaListPaginationLoading";
    Mutations["SET_PAGINATION_CURRENT_PAGE_CHANGE"] = "setMasterSchemaListCurrentPageChange";
    // set loading
    Mutations["SET_LOADING"] = "setPAPostLoading";
    Mutations["SET_MODAL_LOADING"] = "setPAModalLoading";
    Mutations["SET_EDIT_LIST"] = "setPAEditList";
    Mutations["SET_NIK_OPTIONS"] = "setPANikDetailOptions";
    Mutations["SET_SCHEMA_OPTIONS"] = "setPASchemaOptions";
    Mutations["SET_NIK_DETAIL"] = "setPANikDetail";
    // clear form input
    Mutations["CLEAR_FORM_INPUT"] = "clearPAFormInput";
    Mutations["SET_FILTER"] = "setPAFilter";
    Mutations["CLEAR_FILTER"] = "clearPAFilter";
    Mutations["SET_ORDER"] = "setPAListOrderBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
